import React from 'react'
import PropTypes from 'prop-types'
import { Spin as AntSpin } from 'antd'
import { Icon } from 'components/patterns'

const spinIcon = <Icon icon="loading" />

const Spin = ({
  className,
  spinning,
  delay,
  tip,
  children,
  size,
  indicator,
}) => (
  <AntSpin
    size={size}
    className={className}
    tip={tip}
    spinning={spinning}
    delay={delay}
    indicator={indicator}
  >
    {children}
  </AntSpin>
)

Spin.defaultProps = {
  size: 'default',
  delay: 0,
  indicator: spinIcon,
  spinning: false,
}

Spin.propTypes = {
  children: PropTypes.node,
  /** Classname */
  className: PropTypes.string,
  /** Text under spinner */
  tip: PropTypes.string,
  /** isSpinning state */
  spinning: PropTypes.bool,
  /** Spinner icon */
  indicator: PropTypes.node,
  /** Size of spinner */
  size: PropTypes.oneOf(['small', 'default', 'large']),
  /** Wait time to start spinnner */
  delay: PropTypes.number,
}

export default Spin
